"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const WidgetImage = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#FFAB6F",
        d: "M19.778 2H4.222A2.22 2.22 0 0 0 2 4.222v15.556C2 21.005 2.995 22 4.222 22h15.556A2.22 2.22 0 0 0 22 19.778V4.222A2.22 2.22 0 0 0 19.778 2",
        className: styles.accentColor
      }
    ),
    /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M8.89 14 6 18h5.78z" }),
    /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "m14.17 11-4.83 7H19zM7.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" })
  );
};
export default WidgetImage;
